import { render } from "./labelView.vue?vue&type=template&id=60d36c8e&scoped=true"
import script from "./labelView.vue?vue&type=script&lang=js"
export * from "./labelView.vue?vue&type=script&lang=js"

import "./labelView.vue?vue&type=style&index=0&id=60d36c8e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60d36c8e"]])

export default __exports__